import React from 'react';

import Icon from '../AppIcon';

const AuthenticationWrapper = ({
  children,
  title = 'Bienvenue',
  subtitle = '',
  showLogo = true
}) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-background)',
      padding: 'var(--spacing-md)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '480px',
        background: 'var(--color-card)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)',
        padding: 'var(--spacing-xl)',
        border: '1px solid var(--color-border)'
      }}>
        {showLogo && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--spacing-sm)',
            marginBottom: 'var(--spacing-lg)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 'var(--spacing-sm)',
              marginBottom: 'var(--spacing-lg)'
            }}>
              <img src="/immoiq-logo.png" alt="ImmoIQ" style={{ height: '48px', width: 'auto' }} />
              <span style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                fontSize: '1.875rem',
                color: 'var(--color-foreground)'
              }}>
                ImmoIQ
              </span>
            </div>
          </div>
        )}

        <div style={{
          textAlign: 'center',
          marginBottom: 'var(--spacing-lg)'
        }}>
          <h1 style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1.5rem',
            fontWeight: 600,
            color: 'var(--color-foreground)',
            marginBottom: 'var(--spacing-xs)'
          }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.875rem',
              color: 'var(--color-muted-foreground)',
              lineHeight: 1.6
            }}>
              {subtitle}
            </p>
          )}
        </div>

        {children}

        <div style={{
          marginTop: 'var(--spacing-lg)',
          paddingTop: 'var(--spacing-md)',
          borderTop: '1px solid var(--color-border)',
          textAlign: 'center'
        }}>
          <p style={{
            fontFamily: 'var(--font-caption)',
            fontSize: '0.75rem',
            color: 'var(--color-muted-foreground)',
            lineHeight: 1.6
          }}>
            Plateforme sécurisée pour l'investissement immobilier au Québec
          </p>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--spacing-sm)',
            marginTop: 'var(--spacing-xs)'
          }}>
            <Icon name="Shield" size={14} color="var(--color-success)" />
            <span style={{
              fontFamily: 'var(--font-caption)',
              fontSize: '0.75rem',
              color: 'var(--color-success)',
              fontWeight: 500
            }}>
              Données cryptées et conformes
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationWrapper;